import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_75hpx939: FaireBrandEntity = {
  token: "b_75hpx939",
  type: "brand",
  name: "Babe Basics",
  avatarUrl:
    "https://cdn.faire.com/fastly/855e38a3a9e77c32cd5b39f793c24c28961145808ef87c67a8c47528a9fa4007.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/47b075b5dff70a614e60f2037cde19aa21ad7b8319624bdf174a8c127b483491.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/855e38a3a9e77c32cd5b39f793c24c28961145808ef87c67a8c47528a9fa4007.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/47b075b5dff70a614e60f2037cde19aa21ad7b8319624bdf174a8c127b483491.jpeg",
  location: "Scottsdale, AZ, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 106,
  isTopShop: true,
  isInsider: true,
  description:
    "We’ve all had that moment: The birthday party or family photo session is three days away. You totally meant to find your babe a perfectly-accessorized outfit back when you put this date on the calendar, but who has the time to shop around a dozen online baby boutiques when you have a hundred other to-dos spinning around your brain and your little one is growing out of outfits like crazy?\n\nWe created Babe Basics specifically for these kind of moments. We know moms like you and your customers have so much on your plate, and we’re here to make it simple to find sweet, stylish baby products for the special moments in your little ones’ lives.\n\nSure, we obsess over adorable little linen rompers and melt a little when we see those chunky baby legs in a pair of moccasins. But at the heart of every decision we make is the question “How can we make life a little simpler for parents?”\n\nIt’s why we offer all the pieces you need to coordinate the perfect outfit - from the clothes to the shoes and accessories - all in one place and in neutral, mix-and-match styles.\n\nPlease note: We allow the use of our flat-lay images but not those with models/children. We do not allow the use of our product descriptions and appreciate you writing your own for SEO reasons. We do not support/allow private labeling or fulfill presale orders. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:44.694Z",
    importedBy: "entity-db-cli",
  },
};
